export const messages = {
    en: {
      adminStaffDetail: {
        title: 'Staff Information',
        staffId: 'Staff ID',
        userName: 'Name',
        idCard: 'ID Card',
        tel: 'Phone',
        sex: 'Gender',
        male: 'Male',
        female: 'Female',
        address: 'Address',
        privilege: 'Organization Privileges',
        classes: 'Schedule',
        attendance: 'Attendance',
        repair: 'Repair',
        inspection: 'Inspection',
        maintainance: 'Maintenance',
        purchaseApply: 'Purchase',
        itemOutApply: 'Item Out',
        hisFee: 'Fee Receipt',
        applyReturnFee: 'Refund Receipt',
        contract: 'Draft Contract',
        appAuth: 'Staff Authentication',
        accessControl: 'Face Synchronization',
        fetchError: 'Failed to fetch staff information'
      },
      staffDetailPrivilege: {
        orgs: 'Organizations',
        orgName: 'Organization Name',
        relCdName: 'Relationship Code',
        roles: 'Roles',
        privileges: 'Privileges',
        fetchPrivilegesError: 'Failed to fetch privileges',
        fetchOrgsError: 'Failed to fetch organizations',
        fetchRolesError: 'Failed to fetch roles'
      },
      staffDetailClasses: {
        enterDate: 'Enter Date (YYYY-MM)',
        rest: 'Rest',
        fetchError: 'Failed to fetch schedule classes'
      },
      staffDetailAttendance: {
        enterDate: 'Enter Date (YYYY-MM)',
        checkIn: 'Check In',
        checkOut: 'Check Out',
        attendanceLog: 'Attendance Log',
        notYet: 'Not Yet',
        noAttendance: 'No Attendance',
        fetchError: 'Failed to fetch attendance data'
      },
      staffAttendanceDetail: {
        title: 'Attendance Log',
        face: 'Face Image',
        staffName: 'Staff Name',
        clockTime: 'Clock Time',
        fetchError: 'Failed to fetch attendance log'
      },
      staffDetailRepair: {
        undoOrder: 'Pending',
        doneOrder: 'Completed',
        repairId: 'Repair ID',
        location: 'Location',
        repairType: 'Repair Type',
        maintenanceType: 'Maintenance Type',
        paidService: 'Paid Service',
        freeService: 'Free Service',
        materialRequired: 'Material Required',
        noMaterial: 'No Material',
        repairPerson: 'Repair Person',
        contact: 'Contact',
        appointmentTime: 'Appointment Time',
        status: 'Status',
        timedTask: 'Timed Task',
        fetchError: 'Failed to fetch repair data'
      },
      staffDetailInspection: {
        notStarted: 'Not Started',
        inProgress: 'In Progress',
        completed: 'Completed',
        taskDetailId: 'Task Detail ID',
        inspectionName: 'Inspection Name',
        inspectionPlanName: 'Plan Name',
        routeName: 'Route Name',
        planTime: 'Plan Time',
        pointTime: 'Point Time',
        actualInspectionTime: 'Actual Inspection Time',
        inspectionState: 'Inspection State',
        planUserName: 'Plan User',
        actualUserName: 'Actual User',
        signType: 'Sign Type',
        taskState: 'Task State',
        description: 'Description',
        photos: 'Photos',
        createTime: 'Create Time',
        location: 'Location',
        noLocation: 'No location data available',
        fetchError: 'Failed to fetch inspection data'
      },
      staffDetailMaintainance: {
        notStarted: 'Not Started',
        pendingCheck: 'Pending Check',
        completed: 'Completed',
        taskDetailId: 'Task Detail ID',
        machineName: 'Machine Name',
        planName: 'Plan Name',
        standardName: 'Standard Name',
        planUserName: 'Plan User',
        planTime: 'Plan Time',
        actualInspectionTime: 'Actual Inspection Time',
        actualUserName: 'Actual User',
        taskState: 'Task State',
        description: 'Description',
        photos: 'Photos',
        createTime: 'Create Time',
        fetchError: 'Failed to fetch maintenance data'
      },
      staffDetailPurchaseApply: {
        applyOrderId: 'Apply Order ID',
        userName: 'User Name',
        endUserName: 'End User Name',
        createUserName: 'Create User Name',
        resourceNames: 'Resource Names',
        createTime: 'Create Time',
        warehousingWay: 'Warehousing Way',
        direct: 'Direct',
        purchase: 'Purchase',
        urgent: 'Urgent',
        stateName: 'State',
        fetchError: 'Failed to fetch purchase apply data'
      },
      staffDetailItemOutApply: {
        applyOrderId: 'Apply Order ID',
        resourceNames: 'Resource Names',
        userName: 'User Name',
        createUserName: 'Create User Name',
        createTime: 'Create Time',
        stateName: 'State',
        warehousingWay: 'Warehousing Way',
        direct: 'Direct',
        review: 'Review',
        fetchError: 'Failed to fetch item out apply data'
      },
      staffDetailHisFee: {
        feeName: 'Fee Name',
        payerObjName: 'Payer Object',
        cycles: 'Cycles',
        amount: 'Amount',
        acctAmount: 'Account Amount',
        primeRateName: 'Prime Rate',
        feePeriod: 'Fee Period',
        createTime: 'Create Time',
        cashierName: 'Cashier Name',
        stateName: 'State',
        remark: 'Remark',
        fetchError: 'Failed to fetch fee details'
      },
      staffDetailApplyReturnFee: {
        selectState: 'Select State',
        returnFeeId: 'Return Fee ID',
        detailId: 'Detail ID',
        feeTypeCdName: 'Fee Type',
        payerObjName: 'Payer Object',
        cycles: 'Cycles',
        receivableAmount: 'Receivable Amount',
        receivedAmount: 'Received Amount',
        createTime: 'Create Time',
        reason: 'Reason',
        applyPersonName: 'Apply Person',
        stateName: 'State',
        auditPersonName: 'Audit Person',
        fetchError: 'Failed to fetch return fee data',
        fetchDictError: 'Failed to fetch dictionary data'
      },
      staffDetailContract: {
        contractId: 'Contract ID',
        contractNo: 'Contract No',
        contractName: 'Contract Name',
        partyA: 'Party A',
        partyB: 'Party B',
        contractPeriod: 'Contract Period',
        stateName: 'State',
        fetchError: 'Failed to fetch contract data'
      },
      staffDetailAppAuth: {
        authId: 'Auth ID',
        appName: 'App Name',
        authTime: 'Auth Time',
        stateName: 'State',
        fetchError: 'Failed to fetch app auth data'
      },
      staffDetailAccessControl: {
        accessId: 'Access ID',
        deviceName: 'Device Name',
        syncTime: 'Sync Time',
        stateName: 'State',
        fetchError: 'Failed to fetch access control data'
      }
    },
    zh: {
      adminStaffDetail: {
        title: '员工信息',
        staffId: '编号',
        userName: '名称',
        idCard: '身份证',
        tel: '手机',
        sex: '性别',
        male: '男',
        female: '女',
        address: '住址',
        privilege: '组织权限',
        classes: '排班',
        attendance: '考勤',
        repair: '维修',
        inspection: '巡检',
        maintainance: '保养',
        purchaseApply: '采购',
        itemOutApply: '领用',
        hisFee: '收费单',
        applyReturnFee: '退费单',
        contract: '起草合同',
        appAuth: '员工认证',
        accessControl: '人脸同步',
        fetchError: '获取员工信息失败'
      },
      staffDetailPrivilege: {
        orgs: '组织',
        orgName: '组织名称',
        relCdName: '关系代码',
        roles: '角色',
        privileges: '权限',
        fetchPrivilegesError: '获取权限失败',
        fetchOrgsError: '获取组织失败',
        fetchRolesError: '获取角色失败'
      },
      staffDetailClasses: {
        enterDate: '输入日期 (YYYY-MM)',
        rest: '休息',
        fetchError: '获取排班数据失败'
      },
      staffDetailAttendance: {
        enterDate: '输入日期 (YYYY-MM)',
        checkIn: '签到',
        checkOut: '签退',
        attendanceLog: '考勤记录',
        notYet: '尚未到达',
        noAttendance: '无考勤',
        fetchError: '获取考勤数据失败'
      },
      staffAttendanceDetail: {
        title: '考勤记录',
        face: '人脸图像',
        staffName: '员工名称',
        clockTime: '打卡时间',
        fetchError: '获取考勤记录失败'
      },
      staffDetailRepair: {
        undoOrder: '待处理',
        doneOrder: '已完成',
        repairId: '维修ID',
        location: '地点',
        repairType: '维修类型',
        maintenanceType: '维护类型',
        paidService: '付费服务',
        freeService: '免费服务',
        materialRequired: '需要材料',
        noMaterial: '无需材料',
        repairPerson: '维修人员',
        contact: '联系方式',
        appointmentTime: '预约时间',
        status: '状态',
        timedTask: '定时任务',
        fetchError: '获取维修数据失败'
      },
      staffDetailInspection: {
        notStarted: '未开始',
        inProgress: '进行中',
        completed: '已完成',
        taskDetailId: '任务详情ID',
        inspectionName: '巡检名称',
        inspectionPlanName: '计划名称',
        routeName: '路线名称',
        planTime: '计划时间',
        pointTime: '点时间',
        actualInspectionTime: '实际巡检时间',
        inspectionState: '巡检状态',
        planUserName: '计划用户',
        actualUserName: '实际用户',
        signType: '签到类型',
        taskState: '任务状态',
        description: '描述',
        photos: '照片',
        createTime: '创建时间',
        location: '位置',
        noLocation: '无位置数据',
        fetchError: '获取巡检数据失败'
      },
      staffDetailMaintainance: {
        notStarted: '未开始',
        pendingCheck: '待审核',
        completed: '已完成',
        taskDetailId: '任务详情ID',
        machineName: '设备名称',
        planName: '计划名称',
        standardName: '标准名称',
        planUserName: '计划用户',
        planTime: '计划时间',
        actualInspectionTime: '实际巡检时间',
        actualUserName: '实际用户',
        taskState: '任务状态',
        description: '描述',
        photos: '照片',
        createTime: '创建时间',
        fetchError: '获取保养数据失败'
      },
      staffDetailPurchaseApply: {
        applyOrderId: '申请订单ID',
        userName: '用户名',
        endUserName: '最终用户名',
        createUserName: '创建用户名',
        resourceNames: '资源名称',
        createTime: '创建时间',
        warehousingWay: '入库方式',
        direct: '直接',
        purchase: '采购',
        urgent: '紧急',
        stateName: '状态',
        fetchError: '获取采购申请数据失败'
      },
      staffDetailItemOutApply: {
        applyOrderId: '申请订单ID',
        resourceNames: '资源名称',
        userName: '用户名',
        createUserName: '创建用户名',
        createTime: '创建时间',
        stateName: '状态',
        warehousingWay: '入库方式',
        direct: '直接',
        review: '审核',
        fetchError: '获取领用申请数据失败'
      },
      staffDetailHisFee: {
        feeName: '费用名称',
        payerObjName: '付款对象',
        cycles: '周期',
        amount: '金额(元)',
        acctAmount: '账户金额(元)',
        primeRateName: '主要费率',
        feePeriod: '费用周期',
        createTime: '创建时间',
        cashierName: '收银员名称',
        stateName: '状态',
        remark: '备注',
        fetchError: '获取费用详情失败'
      },
      staffDetailApplyReturnFee: {
        selectState: '选择状态',
        returnFeeId: '退费ID',
        detailId: '详情ID',
        feeTypeCdName: '费用类型',
        payerObjName: '付款对象',
        cycles: '周期',
        receivableAmount: '应收金额(元)',
        receivedAmount: '实收金额(元)',
        createTime: '创建时间',
        reason: '原因',
        applyPersonName: '申请人',
        stateName: '状态',
        auditPersonName: '审核人',
        fetchError: '获取退费数据失败',
        fetchDictError: '获取字典数据失败'
      },
      staffDetailContract: {
        contractId: '合同ID',
        contractNo: '合同编号',
        contractName: '合同名称',
        partyA: '甲方',
        partyB: '乙方',
        contractPeriod: '合同周期',
        stateName: '状态',
        fetchError: '获取合同数据失败'
      },
      staffDetailAppAuth: {
        authId: '认证ID',
        appName: '应用名称',
        authTime: '认证时间',
        stateName: '状态',
        fetchError: '获取应用认证数据失败'
      },
      staffDetailAccessControl: {
        accessId: '门禁ID',
        deviceName: '设备名称',
        syncTime: '同步时间',
        stateName: '状态',
        fetchError: '获取门禁数据失败'
      }
    }
  }